import { Injectable } from '@angular/core';
import { ModelAdapter } from '@challenger/care/models/model-adapter.interface';

import { UserClaim } from '@challenger/care/models/user-claim.model';

@Injectable({
  providedIn: 'root',
})
export class UserClaimAdapter implements ModelAdapter<UserClaim> {
  constructor() {}
  adapt(item: any): UserClaim {
    return new UserClaim(
      item.sub,
      item.aud,
      item.jti,
      item.iss,
      item.iat,
      item.exp,
      item.auth_time,
      item.displayName,
      item.vmUserType,
      item.vmAccountID,
      item.vmUserID,
      item.vmHouseholdID,
      item['pi.sri'],
      item.nonce,
      item.s_hash
    );
  }
}
